// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_oao","cls2":"AuthorsCard-cls2_UJH AuthorsCard-cls1_oao"};